import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { getCSRFToken } from '../common/Csrf'

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core";

import AppContainer from "../common/AppContainer";
import Submit from "../common/Submit";
import TextField from "../common/TextField";

import { connect } from "react-redux";
import * as authActions from "./actions";

const styles = {
    passwordError: {
        color: "red",
        textAlign: "center",
    },
};

class PasswordRecoverPage extends Component {
    state = {
        loading: null,
        error: null
    };

    // Check if token is still valid
    componentDidMount=() => {
        const _this = this;
        _this.setState({loading: true})
        fetch("/_allauth/browser/v1/auth/password/reset", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRFToken": getCSRFToken(),
                "X-Password-Reset-Key": _this.props.match.params["key"]
            }
        }).then(function(response) {
            if (response.status === 400)
                _this.setState({loading: false, error: true});
            else
                _this.setState({loading: false});
        })
    }

    errorValidator = (values) => {
        const validatePassword = (password, password2) => {
            if (password !== password2) return "Passwords do not match";
            else if (!password || password.length < 8) return "Invalid password";
            else return null;
        };
        return {
            password: validatePassword(values.password, values.password2),
            password2: validatePassword(values.password, values.password2),
        };
    };

    passwordSubmit = (values) => {
        this.props.authPasswordRecover({
            password: values.password,
            key: this.props.match.params["key"]
        });
    };

    render() {
        const { classes, passwordRecover } = this.props;
        const { error, loading } = this.state;

        if (passwordRecover.success) {
            this.props.history.push("/");  //this doesnt handle kent oauth not sure if we can do anything about if they have isssues
        }

        return (
            <AppContainer>
                <Grid container justifyContent="center">
                    <Grid item xs={12} sm={10} md={6}>
                        <Card>
                            <CardContent>
                                <Typography variant="h5" gutterBottom>
                                    Password Reset
                                </Typography>
                                {loading && (
                                    <Typography>Please wait...</Typography>
                                )}
                                {!loading && error ? (
                                    <Typography style={{color:"darkred"}}>The password reset token was invalid. If you initiated multiple requests be sure to use the link from the latest received email.</Typography>
                                ) : !loading && (
                                    <Form
                                        dontValidateOnMount="true"
                                        validateOnSubmit="true"
                                        validateError={this.errorValidator}
                                        onSubmit={this.passwordSubmit}>
                                        {(formApi) => (
                                            <form onSubmit={formApi.submitForm}>
                                                <Typography className={classes.passwordError}>{passwordRecover.error}</Typography>
                                                {passwordRecover.success && <p>Your password has been updated. Return to the home page to log in.</p>}
                                                <TextField
                                                    field="password"
                                                    type="password"
                                                    label="Password"
                                                    helperText="Must be at least 8 characters."
                                                    fullWidth
                                                />
                                                <TextField
                                                    style={{ marginTop: 16 }}
                                                    field="password2"
                                                    type="password"
                                                    label="Password"
                                                    helperText="Must match."
                                                    fullWidth
                                                />
                                                <Typography>
                                                    Password Requirements:
                                                    <ul>
                                                        <li>Minimum 8 characters</li>
                                                        <li>Cannot be part of your name or email</li>
                                                        <li>Cannot be entirely numeric</li>
                                                    </ul>
                                                </Typography>
                                                <Submit label="Update" loading={passwordRecover.pending} altAction="/" altLabel="Return to Home Page" />
                                            </form>
                                        )}
                                    </Form>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </AppContainer>
        );
    }
}
PasswordRecoverPage.displayName = "PasswordRecoverPage";
PasswordRecoverPage = connect((state) => ({ passwordRecover: (state.auth && state.auth.passwordRecover) || {} }), authActions)(PasswordRecoverPage);

export default withStyles(styles)(withRouter(PasswordRecoverPage));
